import React from "react";
import { string } from "prop-types"
import { Link } from 'react-router-dom'

function Login({ name, routing, routingTab, login, password }) {
  return (
    <div className="row">
      <div className="col s12 m4 offset-m4">
        <div className="card">
          <div className="card-content">
            <span className="card-title">Connexion {name}</span>

            <div className="row">
              <form className="col s12">

                <div className="row">
                  <div className="input-field col s12">
                    <input id="login" type="text" className="validate" defaultValue={login} placeholder="Login" />
                      <label htmlFor="login"></label>
                  </div>
                </div>
                <div className="row">
                  <div className="input-field col s12">
                    <input id="password" type="password" className="validate" defaultValue={password} placeholder="Password"/>
                      <label htmlFor="password"></label>
                  </div>
                </div>
                <div className="row">
                  <div className="input-field col s12 center-align">
                    <Link className={"waves-effect waves-light btn "+routing} to={"/"+routing+"/"+routingTab}>Se connecter</Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

  )
}

Login.propTypes = {
  name: string,
  routing: string,
  routingTab: string,
  login: string,
  password: string
}

export default Login;